import { Component, OnDestroy, OnInit } from '@angular/core';
import { AtivitiesService } from '../../../+home/+activities/ativities.service';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

@Component({
  selector: 'syn-team-presentation',
  templateUrl: './team-presentation.component.html',
  styleUrls: ['./team-presentation.component.scss'],
  animations: [
    trigger('fade', [
      state(
        'void',
        style({
          opacity: 0
        })
      ),
      transition(':enter,:leave', animate(1000))
    ])
  ]
})
export class TeamPresentationComponent implements OnInit, OnDestroy {
  public loadingImagesNotaires: boolean;
  public imagesNotaires: any[];
  public intervalImages;
  public doDisplayItem: boolean;

  constructor(private activitiesService: AtivitiesService) {
  }

  ngOnInit(): void {
    this.loadImages().then(() => {
      this.doDisplayItem = true;
    });
  }

  public startInterval() {
    this.intervalImages = setInterval(() => {
      this.doDisplayItem = false;
      this.changeNotaire();
    }, 10000);
  }

  public stopInterval() {
    clearInterval(this.intervalImages);
  }

  private loadImages() {
    this.imagesNotaires = [];
    this.loadingImagesNotaires = true;

    return this.activitiesService.getNotaireImages().then(res => {
      for (let i = 0; i < res.length; i++) {
        const id = /[^/]*$/.exec(res[i].nodeRef)[0];


        const image = {
          image: this.activitiesService.formatUrl(id),
          index: i,
          thumbImage: this.activitiesService.formatUrl(id),
          title: res[i].title,
          description: res[i].description
        };
        this.imagesNotaires.push(image);
      }

      // On mélange le contenu au hasard
      this.imagesNotaires.sort(() => Math.random() - 0.5);

      this.startInterval();
      this.loadingImagesNotaires = false;
    });
  }

  private changeNotaire() {
    const removedItem = this.imagesNotaires.shift();
    this.imagesNotaires.push(removedItem);

    setTimeout(() => (this.doDisplayItem = true), 1000);
  }

  ngOnDestroy() {
    this.stopInterval();
  }
}
